function Home() {
    return (
        <>
        <h5>Home</h5>
        <div className="Home">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt minus odio, eligendi possimus perspiciatis aliquam est eos maiores doloremque id? Velit sint omnis corporis fuga et quibusdam natus provident quo!
        </div>
        </>
    )
}

export default Home